import React, {useEffect} from "react";
import { GoogleMap, MarkerClusterer, Marker } from "@react-google-maps/api";
import { Provider, useSelector } from "react-redux";
import store from "../store";
import StatusView from "./StatusView";
import { InfoWindow, OverlayView } from "@react-google-maps/api";
import { useHistory } from "react-router-dom";
let globalUserState = {};

const getIconForMarker = (position, category) => {
  const topView = true;
  const availableImageList = [];
 availableImageList.push("car");
     availableImageList.push("truck");
     availableImageList.push("motorcycle");
     availableImageList.push("tractor");
     availableImageList.push("bus");
     availableImageList.push("pickup");
     availableImageList.push("van");
     availableImageList.push("ambulance");
     availableImageList.push("three_wheeler");
     availableImageList.push("e_rickshaw");
     availableImageList.push("jcb");
     availableImageList.push("crane");
     availableImageList.push("mixer_truck");
     availableImageList.push("person");
     availableImageList.push("arrow");
     availableImageList.push("bicycle");
     availableImageList.push("animal");
     availableImageList.push("boat");
     availableImageList.push("ship");


  let categoryName = category || "car";
  if (!availableImageList.some((attribute) => attribute === category)) {
    categoryName = "car";
  }
  categoryName = "category_" + (topView ? "top_" : "") + categoryName;

  if (!position || !position.id) return categoryName + "_running";

  const inactiveList = globalUserState.inactive?.deviceIds || [];

  if (inactiveList.includes(position.id)) {
    return categoryName + "_in_active";
  }

  if (position.attributes && position.attributes.motion) {
    return categoryName + "_running";
  }
  if (position.attributes && position.attributes.ignition) {
    return categoryName + "_idle";
  }
  return categoryName + "_stopped";
};

const overlayStyle = {
  // background: "#371dda",
  // border: "1px solid #371dda",
  padding: 1,
  color: "blue",
  fontWeight: 600,

  borderRadius: "3px",
  // marginLeft:'-10px',
};

const MapMarker = (props) => {
  const history = useHistory();

  const [mapMarker, setMapMarker] = React.useState(null);
  const { markerData, location, clusterer, numberPlateState } = props;
  const onLoad = (mapMarker) => {
    setMapMarker(mapMarker);
  };
  const userDeviceState = useSelector(
    (state) => state.userDeviceState.deviceState
  );

  globalUserState = userDeviceState || {};

  useEffect(() => {
    const img = document.querySelectorAll(
      `img[src='images/top_icons/${getIconForMarker(
        markerData,
        markerData.icon
      )}.png#${markerData.id}']`
    );
    img.length > 0 &&
      (img[0].style.transform = `rotate(${markerData.course}deg)`);
  }, [markerData]);
  const onClick = () => {
    const { isInfoOpen, isSelected, markerData, onClick } = props;

    const isOpen = isSelected ? !isInfoOpen : true;

    onClick(isOpen, markerData.id);
  };

  const renderInfoWindow = (markerId) => {
    const { isInfoOpen, isSelected, markerData } = props;
    // const { mapMarker } = this.state;

    if (!isInfoOpen || !isSelected || !mapMarker) {
      return null;
    }

    return (
      <InfoWindow anchor={mapMarker} zIndex={1}>
        <StatusView
          deviceId={markerData.id}
          onShowDetails={(positionId) =>
            history.push(`/position/${positionId}`)
          }
        />
      </InfoWindow>
    );
  };

  return (
    <Marker
      onLoad={onLoad}
      onClick={onClick}
      position={markerData.position}
      clusterer={clusterer}
      zIndex={999}
      options={{
        icon: {
          url: `images/top_icons/${getIconForMarker(
            markerData,
            markerData.icon
          )}.png#${markerData.id}`,
          scaledSize: new window.google.maps.Size(40, 40),
          // rotation: markerData.course,
          // fillColor: markerData.markerColor,
          // strokeColor: markerData.markerColor,
          // fillOpacity: 1,
          // rotation: [210],
        },
      }}
    >
      {numberPlateState && markerData.id && (
        <InfoWindow key={markerData.id} options={{ disableAutoPan: true }}>
          <div style={overlayStyle} key={markerData.id}>
            {markerData.name && markerData.name.split(" ").join("")}
          </div>
        </InfoWindow>
      )}
      {renderInfoWindow(markerData.id)}
    </Marker>
  );
};

const getIconBackgroundColor = (position) => {
  if (!position || !position.id) {
    return "black";
  }

  if (position.attributes && position.attributes.motion) {
    return "#00C49F";
  }

  if (position.attributes && position.attributes.ignition) {
    return "#FFBB28";
  }

  return "#E82C38";
};

const ClusterMap = ({ positions, numberPlateState }) => {
  const id = "positions";
  const [isInfoOpen, setIsInfoOpen] = React.useState(null);
  const [selectedMarkerId, setSelectedMarkerId] = React.useState(null);
  const [showMarker, setShowmarker] = React.useState(true);
  useEffect(() => {
    setShowmarker(false);
    setTimeout(() => {
      setShowmarker(true);
    }, 100);
  }, [numberPlateState]);

  const locations = positions.map((position) => ({
    lat: position.latitude,
    lng: position.longitude,
    ...position,
  }));

  const options = {
    imagePath:
      "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m", // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
  };

  const createKey = (location) => {
    return location.lat + location.lng;
  };

  // const history = useHistory();
  const devices = useSelector(
    (state) => state.devices.items,
    (prev, next) => {
      return prev.length === next.length;
    }
  );

  const createFeature = (position) => {
    const device = devices[position.deviceId] || null;
    return {
      id: position.deviceId,
      name: device ? device.name : "",
      icon: device && (device.category || "default"),
      position: {
        lat: position.latitude,
        lng: position.longitude,
      },
      course: position.course,
      markerColor: getIconBackgroundColor(position),
      attributes: { ...position.attributes },
    };
  };

  const onClick = (isInfoOpen, selectedMarkerId) => {
    setIsInfoOpen(isInfoOpen);
    setSelectedMarkerId(selectedMarkerId);
  };

  if (!showMarker) {
    return null;
  }

  return (
    <div>
      <MarkerClusterer options={options}>
        {(clusterer) =>
          locations.map((location) => {
            const markerData = createFeature(location);
            return (
              <MapMarker
                key={markerData.id}
                markerData={markerData}
                isSelected={markerData.id === selectedMarkerId}
                isInfoOpen={markerData.id === selectedMarkerId && isInfoOpen}
                onClick={onClick}
                clusterer={clusterer}
                numberPlateState={numberPlateState}
              />
              // <Marker key={createKey(location)} position={location} clusterer={clusterer} />
            );
          })
        }
      </MarkerClusterer>
      {/* {positions.map((location) => {
        const markerData = createFeature(location);
        return (
          <MapMarker
            key={markerData.id}
            markerData={markerData}
            isSelected={markerData.id === selectedMarkerId}
            isInfoOpen={markerData.id === selectedMarkerId && isInfoOpen}
            onClick={onClick}
          />
        );
      })} */}
    </div>
  );
};;;;;

export default ClusterMap;
